(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  // Only show the review "thanks" message when this review form was the one submitted
  document.querySelectorAll('.customer-reviews__success[data-form-success]').forEach((el) => {
    if (window.location.hash && window.location.hash !== '#' + el.dataset.formSuccess) el.hidden = true;
  });

  if (!customElements.get('reviews-track')) {
    class ReviewsTrack extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.customer-reviews__list');
        const section = this.closest('.customer-reviews');
        if (!section || !this.list) return;
        section.querySelector('[data-reviews-prev]')?.addEventListener('click', () => this.move(-1));
        section.querySelector('[data-reviews-next]')?.addEventListener('click', () => this.move(1));
      }

      move(direction) {
        const item = this.list.querySelector('.customer-reviews__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 4;
        const atStart = this.list.scrollLeft <= 4;
        let left = direction * step;
        if (direction > 0 && atEnd) left = -this.list.scrollWidth;
        if (direction < 0 && atStart) left = this.list.scrollWidth;
        this.list.scrollBy({ left, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    customElements.define('reviews-track', ReviewsTrack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restock-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restock-request-form')) {
    class RestockRequestForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        // Only show the success message on the form that was actually submitted
        const success = this.querySelector('[data-form-success]');
        if (success && window.location.hash && window.location.hash !== '#' + success.dataset.formSuccess) {
          success.hidden = true;
        }

        this.querySelectorAll('[data-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const input = this.querySelector('#' + button.getAttribute('aria-controls'));
            if (!input) return;
            const next = (parseInt(input.value, 10) || 0) + parseInt(button.dataset.step, 10);
            input.value = Math.max(0, Math.min(99, next));
          });
        });

        this.form.addEventListener('submit', (event) => {
          const pack = this.form.querySelector('select[name="contact[Pack]"]');
          const message = this.form.querySelector('textarea[name="contact[body]"]');
          const quantities = [...this.form.querySelectorAll('.restock-request__qty')];
          const hasCombo = quantities.some((input) => (parseInt(input.value, 10) || 0) > 0);
          const hasPack = pack && pack.value !== '';
          const hasMessage = message && message.value.trim() !== '';
          const error = this.querySelector('[data-empty-error]');

          if (!hasCombo && !hasPack && !hasMessage) {
            event.preventDefault();
            if (error) {
              error.hidden = false;
              error.focus?.();
            }
            return;
          }

          // Leave zero quantities out of the email so it only lists what they asked for
          quantities.forEach((input) => {
            if ((parseInt(input.value, 10) || 0) === 0) input.disabled = true;
          });
          if (pack && !hasPack) pack.disabled = true;
        });
      }
    }
    customElements.define('restock-request-form', RestockRequestForm);
  }

  } catch(e) { console.error(e); }
})();
})();
